import { render, staticRenderFns } from "./sectionMenu.vue?vue&type=template&id=193725a3&"
import script from "./sectionMenu.vue?vue&type=script&lang=js&"
export * from "./sectionMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports